<form class="ssp-search-and-pick-form" [formGroup]="searchForm">
  <mat-form-field class="inputWraper full-width" appearance="outline">
    <span *ngIf="showSearchAndCancelIcons && isSearchIconDisplay" class="hd-icon hd-icon-search search-icon"
      id="searchIcon"></span>
    <input type="text" #search matInput [ngClass]="{ addIndent: showSearchAndCancelIcons, removeIndent: !isSearchIconDisplay }"
      matAutocompleteTrigger #trigger="matAutocompleteTrigger" class="searchInput" [matAutocomplete]="auto"
      [placeholder]="placeholder" matTooltip="{{ !!selectedItem ? displayFn(selectedItem, 'title') : '' }}"
      matTooltipPosition="above" matTooltipClass="assist-mat-tooltip" formControlName="inputControl"
      (focus)="removeSearchIcon()" (blur)="onBlurInput()" (keyup.enter)="search.blur()"/>
    <span *ngIf="!iconSwitch" class="hd-icon-close close-icon"
      (click)="clearSearch()"></span>
      <span *ngIf="iconSwitch" class="hd-icon-add add-new-icon"
      (click)="setFocus()"></span>
  </mat-form-field>

  <mat-autocomplete panelClass="sa-mat-autocomplete-panel" #auto="matAutocomplete"
    [displayWith]="displayWrapped" sa-stop-propagation (opened)="isOpen(true)" (closed)="isOpen(false)">
    <ng-container>
      <mat-option disableRipple sa-stop-propagation
        *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper" [value]="wrappedItem"
        (click)="optionClicked($event, wrappedItem.item)">
        <div class="dropdown-list" >
          <sa-device-icon [form]="wrappedItem.item.form"></sa-device-icon>
          {{wrappedItem.item.deviceName}}
        </div>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</form>
